const ApisEnum = {
  Default: "default",
  Risk: "risk",
  Backoffice: "backoffice",
};

export default ApisEnum;
